export default __webpack_public_path__ + "static/media/DB_Helvethaica_X.827e9485.ttf";